import { Alert } from '@salecycle/ui-component-library';
import { ReactNode } from 'react';
import styled from 'styled-components';

export type ValidationAlertProps = {
  heading: string;
  isValid: boolean;
  details?: Array<{
    title?: string;
    errors: string[];
    validProps: string[];
  }>;
  successMessage?: ReactNode;
};

const List = styled.ol`
  padding-left: 10px;
`;

const ListItem = styled.li`
  position: relative;
  margin-bottom: 10px;
  list-style: none;
  counter-increment: list-counter;
  padding-left: 20px;

  ul {
    padding-left: 20px;
  }

  &::before {
    content: counter(list-counter) '. ';
    font-weight: bold;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const ValidationAlert = ({ heading, isValid, details, successMessage }: ValidationAlertProps) => {
  return (
    <Alert heading={heading} variant={isValid ? 'success' : 'warning'}>
      {isValid && successMessage}
      {details?.length && (
        <List>
          {details.map(({ title, errors, validProps }, index) => (
            <ListItem key={index}>
              {title && <strong>{title}</strong>}
              <ul>
                {[...validProps, ...errors].map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </ListItem>
          ))}
        </List>
      )}
    </Alert>
  );
};
